import { FinanceApprovalItem } from "@/services/financeService";
import { Button, Modal } from "antd";

interface ApprovalConfirmationModalProps {
  open: boolean;
  approval: FinanceApprovalItem | null;
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ApprovalConfirmationModal = ({
  open,
  approval,
  loading,
  onConfirm,
  onCancel,
}: ApprovalConfirmationModalProps) => {
  if (!approval) return null;

  return (
    <Modal
      title="Confirm Invoice Approval"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button key="confirm" type="primary" loading={loading} onClick={onConfirm}>
          Approve Invoice
        </Button>,
      ]}
      destroyOnClose
    >
      <div className="space-y-4">
        <p className="text-gray-600">
          Are you sure you want to approve this invoice? Please review the details below.
        </p>
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-500">Company</p>
              <p className="font-medium">{approval.companyName || "—"}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Client</p>
              <p className="font-medium">{approval.clientName || "—"}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Amount</p>
              <p className="font-bold text-lg">
                ${Number(approval.amount || 0).toLocaleString()}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Submitted By</p>
              <p className="font-medium">{approval.submittedBy || "—"}</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ApprovalConfirmationModal;
